import * as React from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { enabledLanguages, LANGUAGE_LABELS } from '../../utils/languages';

/**
 * Language dropdown over the languages the app supports (Finnish, English, Swedish).
 * `onChange` receives the Select change event, like a plain MUI Select. A stored value
 * outside the enabled set is still listed so the Select never goes out of range.
 * `allowEmpty` adds an empty "use organization default" option labelled `emptyLabel`.
 */
export default function LanguageSelect({
  value,
  onChange,
  label,
  size,
  fullWidth = false,
  sx,
  disabled = false,
  name,
  allowEmpty = false,
  emptyLabel = '',
  helperText,
}) {
  const languages = enabledLanguages(value);

  return (
    <FormControl size={size} fullWidth={fullWidth} sx={sx} disabled={disabled}>
      {label ? <InputLabel>{label}</InputLabel> : null}
      <Select name={name} value={value ?? ''} label={label} onChange={onChange}>
        {allowEmpty && <MenuItem value="">{emptyLabel}</MenuItem>}
        {languages.map((code) => (
          <MenuItem key={code} value={code}>
            {LANGUAGE_LABELS[code] ?? code}
          </MenuItem>
        ))}
      </Select>
      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </FormControl>
  );
}
